// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';
import type { PingControllerGetError, PingControllerGetResponse, HealthControllerGetError, HealthControllerGetResponse, UserControllerGetUsersData, UserControllerGetUsersError, UserControllerGetUsersResponse, UserControllerCreateUserData, UserControllerCreateUserError, UserControllerCreateUserResponse, UserControllerLoginUserError, UserControllerLoginUserResponse, UserControllerGetUserData, UserControllerGetUserError, UserControllerGetUserResponse, UserControllerUpdateUserData, UserControllerUpdateUserError, UserControllerUpdateUserResponse, UserControllerDeleteUserData, UserControllerDeleteUserError, UserControllerDeleteUserResponse, DeliveryControllerGetDeliveriesData, DeliveryControllerGetDeliveriesError, DeliveryControllerGetDeliveriesResponse, DeliveryControllerGetFilterOptionsData, DeliveryControllerGetFilterOptionsError, DeliveryControllerGetFilterOptionsResponse, DeliveryControllerGetDeliveryData, DeliveryControllerGetDeliveryError, DeliveryControllerGetDeliveryResponse, DeliveryControllerGetDeliveryImageData, DeliveryControllerGetDeliveryImageError, DeliveryControllerGetDeliveryImageResponse, DeliveryControllerCreateProblemReportData, DeliveryControllerCreateProblemReportError, DeliveryControllerCreateProblemReportResponse, DeliveryControllerUpdateProblemReportData, DeliveryControllerUpdateProblemReportError, DeliveryControllerUpdateProblemReportResponse, JobsiteControllerGetJobsitesData, JobsiteControllerGetJobsitesError, JobsiteControllerGetJobsitesResponse, JobsiteControllerGetJobsiteData, JobsiteControllerGetJobsiteError, JobsiteControllerGetJobsiteResponse, JobsiteControllerUpdateJobsiteData, JobsiteControllerUpdateJobsiteError, JobsiteControllerUpdateJobsiteResponse, ActivityControllerGetActivitiesData, ActivityControllerGetActivitiesError, ActivityControllerGetActivitiesResponse, ActivityControllerGetActivityData, ActivityControllerGetActivityError, ActivityControllerGetActivityResponse, ActivityControllerGetActivityImageData, ActivityControllerGetActivityImageError, ActivityControllerGetActivityImageResponse, ActivityControllerGetActivityLicensePlateData, ActivityControllerGetActivityLicensePlateError, ActivityControllerGetActivityLicensePlateResponse, ActivityControllerGetMaterialClassificationData, ActivityControllerGetMaterialClassificationError, ActivityControllerGetMaterialClassificationResponse, ActivityControllerGetEdgeEstimationData, ActivityControllerGetEdgeEstimationError, ActivityControllerGetEdgeEstimationResponse, ActivityControllerGetSoilClassificationData, ActivityControllerGetSoilClassificationError, ActivityControllerGetSoilClassificationResponse, ActivityControllerGetVolumeEstimationData, ActivityControllerGetVolumeEstimationError, ActivityControllerGetVolumeEstimationResponse, OrganisationControllerGetOrganisationData, OrganisationControllerGetOrganisationError, OrganisationControllerGetOrganisationResponse, PredictionControllerGetMaterialClassificationByImageIdData, PredictionControllerGetMaterialClassificationByImageIdError, PredictionControllerGetMaterialClassificationByImageIdResponse, PredictionControllerGetEdgeSizesPredictionByImageIdData, PredictionControllerGetEdgeSizesPredictionByImageIdError, PredictionControllerGetEdgeSizesPredictionByImageIdResponse, PredictionControllerGetSoilClassificationByImageIdData, PredictionControllerGetSoilClassificationByImageIdError, PredictionControllerGetSoilClassificationByImageIdResponse, PredictionControllerGetVolumeEstimationByImageIdData, PredictionControllerGetVolumeEstimationByImageIdError, PredictionControllerGetVolumeEstimationByImageIdResponse, SelfServiceSessionControllerRequestSelfServiceSessionData, SelfServiceSessionControllerRequestSelfServiceSessionError, SelfServiceSessionControllerRequestSelfServiceSessionResponse, SelfServiceSessionControllerGetSelfServiceSessionData, SelfServiceSessionControllerGetSelfServiceSessionError, SelfServiceSessionControllerGetSelfServiceSessionResponse, SelfServiceSessionControllerRequestInitialInstructionData, SelfServiceSessionControllerRequestInitialInstructionError, SelfServiceSessionControllerRequestInitialInstructionResponse, SelfServiceSessionControllerRequestNextInstructionData, SelfServiceSessionControllerRequestNextInstructionError, SelfServiceSessionControllerRequestNextInstructionResponse, SelfServiceSessionControllerGetSessionImagesData, SelfServiceSessionControllerGetSessionImagesError, SelfServiceSessionControllerGetSessionImagesResponse, SelfServiceSessionControllerGetSessionImageData, SelfServiceSessionControllerGetSessionImageError, SelfServiceSessionControllerGetSessionImageResponse, SelfServiceSessionControllerGetSessionImageEdgeSizesData, SelfServiceSessionControllerGetSessionImageEdgeSizesError, SelfServiceSessionControllerGetSessionImageEdgeSizesResponse, SelfServiceSessionControllerGetSessionImageMaterialClassificationData, SelfServiceSessionControllerGetSessionImageMaterialClassificationError, SelfServiceSessionControllerGetSessionImageMaterialClassificationResponse, SelfServiceSessionControllerGetSessionImageSoilClassificationData, SelfServiceSessionControllerGetSessionImageSoilClassificationError, SelfServiceSessionControllerGetSessionImageSoilClassificationResponse, SelfServiceSessionControllerGetSessionLicensePlateData, SelfServiceSessionControllerGetSessionLicensePlateError, SelfServiceSessionControllerGetSessionLicensePlateResponse, SelfServiceSessionControllerGetKnownLicensePlatesData, SelfServiceSessionControllerGetKnownLicensePlatesError, SelfServiceSessionControllerGetKnownLicensePlatesResponse, SelfServiceSessionControllerGetKnownConstructionSitesData, SelfServiceSessionControllerGetKnownConstructionSitesError, SelfServiceSessionControllerGetKnownConstructionSitesResponse, SelfServiceSessionControllerSubmitImageFeedbackData, SelfServiceSessionControllerSubmitImageFeedbackError, SelfServiceSessionControllerSubmitImageFeedbackResponse, SelfServiceSessionControllerProcessSessionEventData, SelfServiceSessionControllerProcessSessionEventError, SelfServiceSessionControllerProcessSessionEventResponse, HeapControllerTriggerHeapCaptureData, HeapControllerTriggerHeapCaptureError, HeapControllerTriggerHeapCaptureResponse, HeapControllerGetPresignedDownloadUrlData, HeapControllerGetPresignedDownloadUrlError, HeapControllerGetPresignedDownloadUrlResponse, HeapControllerSubmitComplaintData, HeapControllerSubmitComplaintError, HeapControllerSubmitComplaintResponse, BillableMaterialControllerGetBillableMaterialsData, BillableMaterialControllerGetBillableMaterialsError, BillableMaterialControllerGetBillableMaterialsResponse, BillableMaterialControllerCreateBillableMaterialData, BillableMaterialControllerCreateBillableMaterialError, BillableMaterialControllerCreateBillableMaterialResponse, BillableMaterialControllerUpdateBillableMaterialData, BillableMaterialControllerUpdateBillableMaterialError, BillableMaterialControllerUpdateBillableMaterialResponse, BillableMaterialControllerDeleteBillableMaterialData, BillableMaterialControllerDeleteBillableMaterialError, BillableMaterialControllerDeleteBillableMaterialResponse, RecordingControllerGetRecordingImageData, RecordingControllerGetRecordingImageError, RecordingControllerGetRecordingImageResponse, RecordingControllerCreateProblemReportData, RecordingControllerCreateProblemReportError, RecordingControllerCreateProblemReportResponse, RecordingControllerUpdateProblemReportData, RecordingControllerUpdateProblemReportError, RecordingControllerUpdateProblemReportResponse, TruckRecordingControllerGetRecordingsData, TruckRecordingControllerGetRecordingsError, TruckRecordingControllerGetRecordingsResponse, TruckRecordingMipControllerGetRecordingsData, TruckRecordingMipControllerGetRecordingsError, TruckRecordingMipControllerGetRecordingsResponse, TruckRecordingMipControllerGetFilterOptionsData, TruckRecordingMipControllerGetFilterOptionsError, TruckRecordingMipControllerGetFilterOptionsResponse, TruckRecordingMipControllerGetRecordingImageData, TruckRecordingMipControllerGetRecordingImageError, TruckRecordingMipControllerGetRecordingImageResponse, TruckRecordingMipControllerGetMaterialClassificationData, TruckRecordingMipControllerGetMaterialClassificationError, TruckRecordingMipControllerGetMaterialClassificationResponse, TruckRecordingMipControllerGetEdgeSizesData, TruckRecordingMipControllerGetEdgeSizesError, TruckRecordingMipControllerGetEdgeSizesResponse, TruckRecordingMipControllerGetSoilClassificationData, TruckRecordingMipControllerGetSoilClassificationError, TruckRecordingMipControllerGetSoilClassificationResponse, TruckRecordingMipControllerGetVolumeEstimationData, TruckRecordingMipControllerGetVolumeEstimationError, TruckRecordingMipControllerGetVolumeEstimationResponse, TrainRecordingControllerGetRecordingsData, TrainRecordingControllerGetRecordingsError, TrainRecordingControllerGetRecordingsResponse, TrainRecordingControllerGetFilterOptionsData, TrainRecordingControllerGetFilterOptionsError, TrainRecordingControllerGetFilterOptionsResponse, TrainRecordingControllerGetRecordingData, TrainRecordingControllerGetRecordingError, TrainRecordingControllerGetRecordingResponse, TrainRecordingControllerGetAuxCapturesData, TrainRecordingControllerGetAuxCapturesError, TrainRecordingControllerGetAuxCapturesResponse, TrainRecordingControllerGetAuxImagesData, TrainRecordingControllerGetAuxImagesError, TrainRecordingControllerGetAuxImagesResponse, TrainRecordingControllerGetAuxImageData, TrainRecordingControllerGetAuxImageError, TrainRecordingControllerGetAuxImageResponse, TrainRecordingControllerGetWagonNumberImageData, TrainRecordingControllerGetWagonNumberImageError, TrainRecordingControllerGetWagonNumberImageResponse, HeapRecordingControllerGetRecordingsData, HeapRecordingControllerGetRecordingsError, HeapRecordingControllerGetRecordingsResponse, HeapRecordingControllerGetFilterOptionsData, HeapRecordingControllerGetFilterOptionsError, HeapRecordingControllerGetFilterOptionsResponse, HeapRecordingControllerUpdateRecordingBatchData, BeltControllerGetBeltObservationsData, BeltControllerGetBeltObservationsError, BeltControllerGetBeltObservationsResponse, BeltControllerGetBeltObservationDaysData, BeltControllerGetBeltObservationDaysError, BeltControllerGetBeltObservationDaysResponse } from './types.gen';

export const client = createClient(createConfig());

export class DefaultService {
    public static pingControllerGet<ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PingControllerGetResponse, PingControllerGetError, ThrowOnError>({
            ...options,
            url: '/'
        });
    }
    
    public static healthControllerGet<ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<HealthControllerGetResponse, HealthControllerGetError, ThrowOnError>({
            ...options,
            url: '/healthz'
        });
    }
    
}

export class UserService {
    /**
     * Get all users
     */
    public static userControllerGetUsers<ThrowOnError extends boolean = false>(options?: Options<UserControllerGetUsersData, ThrowOnError>) {
        return (options?.client ?? client).get<UserControllerGetUsersResponse, UserControllerGetUsersError, ThrowOnError>({
            ...options,
            url: '/api/users'
        });
    }
    
    /**
     * Add a new user
     */
    public static userControllerCreateUser<ThrowOnError extends boolean = false>(options: Options<UserControllerCreateUserData, ThrowOnError>) {
        return (options?.client ?? client).post<UserControllerCreateUserResponse, UserControllerCreateUserError, ThrowOnError>({
            ...options,
            url: '/api/users'
        });
    }
    
    /**
     * Log in a user
     */
    public static userControllerLoginUser<ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<UserControllerLoginUserResponse, UserControllerLoginUserError, ThrowOnError>({
            ...options,
            url: '/api/users/login'
        });
    }
    
    /**
     * Get user info
     */
    public static userControllerGetUser<ThrowOnError extends boolean = false>(options: Options<UserControllerGetUserData, ThrowOnError>) {
        return (options?.client ?? client).get<UserControllerGetUserResponse, UserControllerGetUserError, ThrowOnError>({
            ...options,
            url: '/api/users/{authId}'
        });
    }
    
    /**
     * Update user info
     *
     * Some business logic:
     * - users can: change own preferredJobsite
     * - admins can: change everyones admin status, change users jobsites
     * - admins are users
     * Only provide the value to be changed!
     */
    public static userControllerUpdateUser<ThrowOnError extends boolean = false>(options: Options<UserControllerUpdateUserData, ThrowOnError>) {
        return (options?.client ?? client).put<UserControllerUpdateUserResponse, UserControllerUpdateUserError, ThrowOnError>({
            ...options,
            url: '/api/users/{authId}'
        });
    }
    
    /**
     * Delete user
     */
    public static userControllerDeleteUser<ThrowOnError extends boolean = false>(options: Options<UserControllerDeleteUserData, ThrowOnError>) {
        return (options?.client ?? client).delete<UserControllerDeleteUserResponse, UserControllerDeleteUserError, ThrowOnError>({
            ...options,
            url: '/api/users/{authId}'
        });
    }
    
}

export class DeliveryService {
    /**
     * Get deliveries for a jobsite
     */
    public static deliveryControllerGetDeliveries<ThrowOnError extends boolean = false>(options: Options<DeliveryControllerGetDeliveriesData, ThrowOnError>) {
        return (options?.client ?? client).get<DeliveryControllerGetDeliveriesResponse, DeliveryControllerGetDeliveriesError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/deliveries'
        });
    }
    
    /**
     * Get the available filter values and counts for a query
     */
    public static deliveryControllerGetFilterOptions<ThrowOnError extends boolean = false>(options: Options<DeliveryControllerGetFilterOptionsData, ThrowOnError>) {
        return (options?.client ?? client).get<DeliveryControllerGetFilterOptionsResponse, DeliveryControllerGetFilterOptionsError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/deliveries/filter-options'
        });
    }
    
    /**
     * Get details for a delivery
     */
    public static deliveryControllerGetDelivery<ThrowOnError extends boolean = false>(options: Options<DeliveryControllerGetDeliveryData, ThrowOnError>) {
        return (options?.client ?? client).get<DeliveryControllerGetDeliveryResponse, DeliveryControllerGetDeliveryError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/deliveries/{deliveryId}'
        });
    }
    
    /**
     * Get the image assigned to a delivery
     */
    public static deliveryControllerGetDeliveryImage<ThrowOnError extends boolean = false>(options: Options<DeliveryControllerGetDeliveryImageData, ThrowOnError>) {
        return (options?.client ?? client).get<DeliveryControllerGetDeliveryImageResponse, DeliveryControllerGetDeliveryImageError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/deliveries/{deliveryId}/images/{imageId}'
        });
    }
    
    /**
     * Create problem report for a delivery
     */
    public static deliveryControllerCreateProblemReport<ThrowOnError extends boolean = false>(options: Options<DeliveryControllerCreateProblemReportData, ThrowOnError>) {
        return (options?.client ?? client).post<DeliveryControllerCreateProblemReportResponse, DeliveryControllerCreateProblemReportError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/deliveries/{deliveryId}/feedback'
        });
    }
    
    /**
     * Update problem report for a delivery
     */
    public static deliveryControllerUpdateProblemReport<ThrowOnError extends boolean = false>(options: Options<DeliveryControllerUpdateProblemReportData, ThrowOnError>) {
        return (options?.client ?? client).put<DeliveryControllerUpdateProblemReportResponse, DeliveryControllerUpdateProblemReportError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/deliveries/{deliveryId}/feedback'
        });
    }
    
}

export class JobsiteService {
    /**
     * Get jobsites for an organisation
     */
    public static jobsiteControllerGetJobsites<ThrowOnError extends boolean = false>(options: Options<JobsiteControllerGetJobsitesData, ThrowOnError>) {
        return (options?.client ?? client).get<JobsiteControllerGetJobsitesResponse, JobsiteControllerGetJobsitesError, ThrowOnError>({
            ...options,
            url: '/api/organisations/{organisationId}/jobsites'
        });
    }
    
    /**
     * Get a jobsite
     */
    public static jobsiteControllerGetJobsite<ThrowOnError extends boolean = false>(options: Options<JobsiteControllerGetJobsiteData, ThrowOnError>) {
        return (options?.client ?? client).get<JobsiteControllerGetJobsiteResponse, JobsiteControllerGetJobsiteError, ThrowOnError>({
            ...options,
            url: '/api/organisations/{organisationId}/jobsites/{jobsiteId}'
        });
    }
    
    /**
     * Update a jobsite
     */
    public static jobsiteControllerUpdateJobsite<ThrowOnError extends boolean = false>(options: Options<JobsiteControllerUpdateJobsiteData, ThrowOnError>) {
        return (options?.client ?? client).put<JobsiteControllerUpdateJobsiteResponse, JobsiteControllerUpdateJobsiteError, ThrowOnError>({
            ...options,
            url: '/api/organisations/{organisationId}/jobsites/{jobsiteId}'
        });
    }
    
}

export class ActivityService {
    /**
     * Get activities for a jobsite
     */
    public static activityControllerGetActivities<ThrowOnError extends boolean = false>(options: Options<ActivityControllerGetActivitiesData, ThrowOnError>) {
        return (options?.client ?? client).get<ActivityControllerGetActivitiesResponse, ActivityControllerGetActivitiesError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/activities'
        });
    }
    
    /**
     * Get activity details
     */
    public static activityControllerGetActivity<ThrowOnError extends boolean = false>(options: Options<ActivityControllerGetActivityData, ThrowOnError>) {
        return (options?.client ?? client).get<ActivityControllerGetActivityResponse, ActivityControllerGetActivityError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/activities/{capture_start_at}'
        });
    }
    
    /**
     * Get an activity image
     */
    public static activityControllerGetActivityImage<ThrowOnError extends boolean = false>(options: Options<ActivityControllerGetActivityImageData, ThrowOnError>) {
        return (options?.client ?? client).get<ActivityControllerGetActivityImageResponse, ActivityControllerGetActivityImageError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/activities/{capture_start_at}/image'
        });
    }
    
    /**
     * Get license plate for an activity
     */
    public static activityControllerGetActivityLicensePlate<ThrowOnError extends boolean = false>(options: Options<ActivityControllerGetActivityLicensePlateData, ThrowOnError>) {
        return (options?.client ?? client).get<ActivityControllerGetActivityLicensePlateResponse, ActivityControllerGetActivityLicensePlateError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/activities/{capture_start_at}/licenseplate'
        });
    }
    
    /**
     * Get material classification for an activity
     */
    public static activityControllerGetMaterialClassification<ThrowOnError extends boolean = false>(options: Options<ActivityControllerGetMaterialClassificationData, ThrowOnError>) {
        return (options?.client ?? client).get<ActivityControllerGetMaterialClassificationResponse, ActivityControllerGetMaterialClassificationError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/activities/{capture_start_at}/material-classification'
        });
    }
    
    /**
     * Get edge estimation for an activity
     */
    public static activityControllerGetEdgeEstimation<ThrowOnError extends boolean = false>(options: Options<ActivityControllerGetEdgeEstimationData, ThrowOnError>) {
        return (options?.client ?? client).get<ActivityControllerGetEdgeEstimationResponse, ActivityControllerGetEdgeEstimationError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/activities/{capture_start_at}/edge-estimation'
        });
    }
    
    /**
     * Get soil classification for an activity
     */
    public static activityControllerGetSoilClassification<ThrowOnError extends boolean = false>(options: Options<ActivityControllerGetSoilClassificationData, ThrowOnError>) {
        return (options?.client ?? client).get<ActivityControllerGetSoilClassificationResponse, ActivityControllerGetSoilClassificationError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/activities/{capture_start_at}/soil-classification'
        });
    }
    
    /**
     * Get volume estimation for an activity
     */
    public static activityControllerGetVolumeEstimation<ThrowOnError extends boolean = false>(options: Options<ActivityControllerGetVolumeEstimationData, ThrowOnError>) {
        return (options?.client ?? client).get<ActivityControllerGetVolumeEstimationResponse, ActivityControllerGetVolumeEstimationError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/activities/{capture_start_at}/volume-estimation'
        });
    }
    
}

export class OrganisationService {
    /**
     * Get organisation details
     */
    public static organisationControllerGetOrganisation<ThrowOnError extends boolean = false>(options: Options<OrganisationControllerGetOrganisationData, ThrowOnError>) {
        return (options?.client ?? client).get<OrganisationControllerGetOrganisationResponse, OrganisationControllerGetOrganisationError, ThrowOnError>({
            ...options,
            url: '/api/organisations/{organisationId}'
        });
    }
    
}

export class PredictionsService {
    /**
     * Get material-classifications for an image
     */
    public static predictionControllerGetMaterialClassificationByImageId<ThrowOnError extends boolean = false>(options: Options<PredictionControllerGetMaterialClassificationByImageIdData, ThrowOnError>) {
        return (options?.client ?? client).get<PredictionControllerGetMaterialClassificationByImageIdResponse, PredictionControllerGetMaterialClassificationByImageIdError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/images/{imageId}/predictions/material-classification'
        });
    }
    
    /**
     * Get edge sizes prediction for an image
     */
    public static predictionControllerGetEdgeSizesPredictionByImageId<ThrowOnError extends boolean = false>(options: Options<PredictionControllerGetEdgeSizesPredictionByImageIdData, ThrowOnError>) {
        return (options?.client ?? client).get<PredictionControllerGetEdgeSizesPredictionByImageIdResponse, PredictionControllerGetEdgeSizesPredictionByImageIdError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/images/{imageId}/predictions/edge-sizes'
        });
    }
    
    /**
     * Get soil classification for an image
     */
    public static predictionControllerGetSoilClassificationByImageId<ThrowOnError extends boolean = false>(options: Options<PredictionControllerGetSoilClassificationByImageIdData, ThrowOnError>) {
        return (options?.client ?? client).get<PredictionControllerGetSoilClassificationByImageIdResponse, PredictionControllerGetSoilClassificationByImageIdError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/images/{imageId}/predictions/soil-classification'
        });
    }
    
    /**
     * Get volume estimation for an image
     */
    public static predictionControllerGetVolumeEstimationByImageId<ThrowOnError extends boolean = false>(options: Options<PredictionControllerGetVolumeEstimationByImageIdData, ThrowOnError>) {
        return (options?.client ?? client).get<PredictionControllerGetVolumeEstimationByImageIdResponse, PredictionControllerGetVolumeEstimationByImageIdError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/images/{imageId}/predictions/volume-estimation'
        });
    }
    
}

export class SelfServiceSessionService {
    /**
     * Request a new self-service session. Returns the sessionId on success.
     */
    public static selfServiceSessionControllerRequestSelfServiceSession<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerRequestSelfServiceSessionData, ThrowOnError>) {
        return (options?.client ?? client).post<SelfServiceSessionControllerRequestSelfServiceSessionResponse, SelfServiceSessionControllerRequestSelfServiceSessionError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}'
        });
    }
    
    /**
     * Get details of a self-service session by its ID
     */
    public static selfServiceSessionControllerGetSelfServiceSession<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerGetSelfServiceSessionData, ThrowOnError>) {
        return (options?.client ?? client).get<SelfServiceSessionControllerGetSelfServiceSessionResponse, SelfServiceSessionControllerGetSelfServiceSessionError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}'
        });
    }
    
    /**
     * Request initial instruction
     */
    public static selfServiceSessionControllerRequestInitialInstruction<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerRequestInitialInstructionData, ThrowOnError>) {
        return (options?.client ?? client).post<SelfServiceSessionControllerRequestInitialInstructionResponse, SelfServiceSessionControllerRequestInitialInstructionError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/instruction/{lang}'
        });
    }
    
    /**
     * Submit data and request next instruction
     */
    public static selfServiceSessionControllerRequestNextInstruction<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerRequestNextInstructionData, ThrowOnError>) {
        return (options?.client ?? client).post<SelfServiceSessionControllerRequestNextInstructionResponse, SelfServiceSessionControllerRequestNextInstructionError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/instruction/{instructionId}/{lang}'
        });
    }
    
    /**
     * Get all candidate images associated with a self-service session
     */
    public static selfServiceSessionControllerGetSessionImages<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerGetSessionImagesData, ThrowOnError>) {
        return (options?.client ?? client).get<SelfServiceSessionControllerGetSessionImagesResponse, SelfServiceSessionControllerGetSessionImagesError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/images'
        });
    }
    
    /**
     * Get the image associated with a self-service session by its ID and image number
     */
    public static selfServiceSessionControllerGetSessionImage<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerGetSessionImageData, ThrowOnError>) {
        return (options?.client ?? client).get<SelfServiceSessionControllerGetSessionImageResponse, SelfServiceSessionControllerGetSessionImageError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/image/{index}'
        });
    }
    
    /**
     * Get edge sizes prediction for an image in a self-service session
     */
    public static selfServiceSessionControllerGetSessionImageEdgeSizes<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerGetSessionImageEdgeSizesData, ThrowOnError>) {
        return (options?.client ?? client).get<SelfServiceSessionControllerGetSessionImageEdgeSizesResponse, SelfServiceSessionControllerGetSessionImageEdgeSizesError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/image/{index}/edge-sizes'
        });
    }
    
    /**
     * Get material classification for an image in a self-service session
     */
    public static selfServiceSessionControllerGetSessionImageMaterialClassification<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerGetSessionImageMaterialClassificationData, ThrowOnError>) {
        return (options?.client ?? client).get<SelfServiceSessionControllerGetSessionImageMaterialClassificationResponse, SelfServiceSessionControllerGetSessionImageMaterialClassificationError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/image/{index}/material-classification'
        });
    }
    
    /**
     * Get soil classification for an image in a self-service session
     */
    public static selfServiceSessionControllerGetSessionImageSoilClassification<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerGetSessionImageSoilClassificationData, ThrowOnError>) {
        return (options?.client ?? client).get<SelfServiceSessionControllerGetSessionImageSoilClassificationResponse, SelfServiceSessionControllerGetSessionImageSoilClassificationError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/image/{index}/soil-classification'
        });
    }
    
    /**
     * Get license plate recognition data for the self-service session
     */
    public static selfServiceSessionControllerGetSessionLicensePlate<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerGetSessionLicensePlateData, ThrowOnError>) {
        return (options?.client ?? client).get<SelfServiceSessionControllerGetSessionLicensePlateResponse, SelfServiceSessionControllerGetSessionLicensePlateError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/licenseplate'
        });
    }
    
    /**
     * Get license plates that have already been entered for this jobsite
     */
    public static selfServiceSessionControllerGetKnownLicensePlates<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerGetKnownLicensePlatesData, ThrowOnError>) {
        return (options?.client ?? client).get<SelfServiceSessionControllerGetKnownLicensePlatesResponse, SelfServiceSessionControllerGetKnownLicensePlatesError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/known-licenseplates'
        });
    }
    
    /**
     * Get construction sites that have already been entered for this jobsite
     */
    public static selfServiceSessionControllerGetKnownConstructionSites<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerGetKnownConstructionSitesData, ThrowOnError>) {
        return (options?.client ?? client).get<SelfServiceSessionControllerGetKnownConstructionSitesResponse, SelfServiceSessionControllerGetKnownConstructionSitesError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/known-construction-sites'
        });
    }
    
    /**
     * Submit feedback for the image captured during the self-service session
     */
    public static selfServiceSessionControllerSubmitImageFeedback<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerSubmitImageFeedbackData, ThrowOnError>) {
        return (options?.client ?? client).post<SelfServiceSessionControllerSubmitImageFeedbackResponse, SelfServiceSessionControllerSubmitImageFeedbackError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/image/{index}/feedback'
        });
    }
    
    /**
     * Supports "extend" (prolongs session), "cancel" (ends immediately), and "completed" (ends with delivery association) event types.
     */
    public static selfServiceSessionControllerProcessSessionEvent<ThrowOnError extends boolean = false>(options: Options<SelfServiceSessionControllerProcessSessionEventData, ThrowOnError>) {
        return (options?.client ?? client).post<SelfServiceSessionControllerProcessSessionEventResponse, SelfServiceSessionControllerProcessSessionEventError, ThrowOnError>({
            ...options,
            url: '/api/self-service/jobsites/{jobsiteId}/{sessionId}/events'
        });
    }
    
}

export class HeapService {
    /**
     * Trigger a heap frame capture
     */
    public static heapControllerTriggerHeapCapture<ThrowOnError extends boolean = false>(options: Options<HeapControllerTriggerHeapCaptureData, ThrowOnError>) {
        return (options?.client ?? client).post<HeapControllerTriggerHeapCaptureResponse, HeapControllerTriggerHeapCaptureError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/heap/trigger-heap-frame-capture'
        });
    }
    
    /**
     * Get presigned download URL for heap result file
     */
    public static heapControllerGetPresignedDownloadUrl<ThrowOnError extends boolean = false>(options: Options<HeapControllerGetPresignedDownloadUrlData, ThrowOnError>) {
        return (options?.client ?? client).post<HeapControllerGetPresignedDownloadUrlResponse, HeapControllerGetPresignedDownloadUrlError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/heap/get-presigned-download-url'
        });
    }
    
    /**
     * Submit complaint report for a capture in live view
     */
    public static heapControllerSubmitComplaint<ThrowOnError extends boolean = false>(options: Options<HeapControllerSubmitComplaintData, ThrowOnError>) {
        return (options?.client ?? client).post<HeapControllerSubmitComplaintResponse, HeapControllerSubmitComplaintError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/heap/submit-complaint'
        });
    }
    
}

export class BillableMaterialsService {
    /**
     * Get all billable materials of an organisation.
     */
    public static billableMaterialControllerGetBillableMaterials<ThrowOnError extends boolean = false>(options: Options<BillableMaterialControllerGetBillableMaterialsData, ThrowOnError>) {
        return (options?.client ?? client).get<BillableMaterialControllerGetBillableMaterialsResponse, BillableMaterialControllerGetBillableMaterialsError, ThrowOnError>({
            ...options,
            url: '/api/organisations/{organisationId}/billable-materials'
        });
    }
    
    /**
     * Create a new billable material
     */
    public static billableMaterialControllerCreateBillableMaterial<ThrowOnError extends boolean = false>(options: Options<BillableMaterialControllerCreateBillableMaterialData, ThrowOnError>) {
        return (options?.client ?? client).post<BillableMaterialControllerCreateBillableMaterialResponse, BillableMaterialControllerCreateBillableMaterialError, ThrowOnError>({
            ...options,
            url: '/api/organisations/{organisationId}/billable-materials'
        });
    }
    
    /**
     * Update a billable material
     */
    public static billableMaterialControllerUpdateBillableMaterial<ThrowOnError extends boolean = false>(options: Options<BillableMaterialControllerUpdateBillableMaterialData, ThrowOnError>) {
        return (options?.client ?? client).patch<BillableMaterialControllerUpdateBillableMaterialResponse, BillableMaterialControllerUpdateBillableMaterialError, ThrowOnError>({
            ...options,
            url: '/api/organisations/{organisationId}/billable-materials/{billableMaterialId}'
        });
    }
    
    /**
     * Delete a billable material
     */
    public static billableMaterialControllerDeleteBillableMaterial<ThrowOnError extends boolean = false>(options: Options<BillableMaterialControllerDeleteBillableMaterialData, ThrowOnError>) {
        return (options?.client ?? client).delete<BillableMaterialControllerDeleteBillableMaterialResponse, BillableMaterialControllerDeleteBillableMaterialError, ThrowOnError>({
            ...options,
            url: '/api/organisations/{organisationId}/billable-materials/{billableMaterialId}'
        });
    }
    
}

export class RecordingService {
    /**
     * Get the image for a recording
     */
    public static recordingControllerGetRecordingImage<ThrowOnError extends boolean = false>(options: Options<RecordingControllerGetRecordingImageData, ThrowOnError>) {
        return (options?.client ?? client).get<RecordingControllerGetRecordingImageResponse, RecordingControllerGetRecordingImageError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/recordings/{recordingId}/image'
        });
    }
    
    /**
     * Create problem report for a recording
     */
    public static recordingControllerCreateProblemReport<ThrowOnError extends boolean = false>(options: Options<RecordingControllerCreateProblemReportData, ThrowOnError>) {
        return (options?.client ?? client).post<RecordingControllerCreateProblemReportResponse, RecordingControllerCreateProblemReportError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/recordings/{recordingId}/feedback'
        });
    }
    
    /**
     * Update problem report for a recording
     */
    public static recordingControllerUpdateProblemReport<ThrowOnError extends boolean = false>(options: Options<RecordingControllerUpdateProblemReportData, ThrowOnError>) {
        return (options?.client ?? client).put<RecordingControllerUpdateProblemReportResponse, RecordingControllerUpdateProblemReportError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/recordings/{recordingId}/feedback'
        });
    }
    
}

export class TruckRecordingService {
    /**
     * Get recordings of trucks for a jobsite
     */
    public static truckRecordingControllerGetRecordings<ThrowOnError extends boolean = false>(options: Options<TruckRecordingControllerGetRecordingsData, ThrowOnError>) {
        return (options?.client ?? client).get<TruckRecordingControllerGetRecordingsResponse, TruckRecordingControllerGetRecordingsError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/truck-recordings'
        });
    }
    
}

export class TruckRecordingMipService {
    /**
     * List truck recordings from MIP
     */
    public static truckRecordingMipControllerGetRecordings<ThrowOnError extends boolean = false>(options: Options<TruckRecordingMipControllerGetRecordingsData, ThrowOnError>) {
        return (options?.client ?? client).get<TruckRecordingMipControllerGetRecordingsResponse, TruckRecordingMipControllerGetRecordingsError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/truck-recordings-mip'
        });
    }
    
    /**
     * Get filter options for truck recordings
     */
    public static truckRecordingMipControllerGetFilterOptions<ThrowOnError extends boolean = false>(options: Options<TruckRecordingMipControllerGetFilterOptionsData, ThrowOnError>) {
        return (options?.client ?? client).get<TruckRecordingMipControllerGetFilterOptionsResponse, TruckRecordingMipControllerGetFilterOptionsError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/truck-recordings-mip/filter-options'
        });
    }
    
    /**
     * Get recording image by MIP report ID
     */
    public static truckRecordingMipControllerGetRecordingImage<ThrowOnError extends boolean = false>(options: Options<TruckRecordingMipControllerGetRecordingImageData, ThrowOnError>) {
        return (options?.client ?? client).get<TruckRecordingMipControllerGetRecordingImageResponse, TruckRecordingMipControllerGetRecordingImageError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/truck-recordings-mip/{mipReportId}/image'
        });
    }
    
    /**
     * Get material classification by MIP report ID
     */
    public static truckRecordingMipControllerGetMaterialClassification<ThrowOnError extends boolean = false>(options: Options<TruckRecordingMipControllerGetMaterialClassificationData, ThrowOnError>) {
        return (options?.client ?? client).get<TruckRecordingMipControllerGetMaterialClassificationResponse, TruckRecordingMipControllerGetMaterialClassificationError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/truck-recordings-mip/{mipReportId}/predictions/material-classification'
        });
    }
    
    /**
     * Get edge sizes prediction by MIP report ID
     */
    public static truckRecordingMipControllerGetEdgeSizes<ThrowOnError extends boolean = false>(options: Options<TruckRecordingMipControllerGetEdgeSizesData, ThrowOnError>) {
        return (options?.client ?? client).get<TruckRecordingMipControllerGetEdgeSizesResponse, TruckRecordingMipControllerGetEdgeSizesError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/truck-recordings-mip/{mipReportId}/predictions/edge-sizes'
        });
    }
    
    /**
     * Get soil classification by MIP report ID
     */
    public static truckRecordingMipControllerGetSoilClassification<ThrowOnError extends boolean = false>(options: Options<TruckRecordingMipControllerGetSoilClassificationData, ThrowOnError>) {
        return (options?.client ?? client).get<TruckRecordingMipControllerGetSoilClassificationResponse, TruckRecordingMipControllerGetSoilClassificationError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/truck-recordings-mip/{mipReportId}/predictions/soil-classification'
        });
    }
    
    /**
     * Get volume estimation prediction by MIP report ID
     */
    public static truckRecordingMipControllerGetVolumeEstimation<ThrowOnError extends boolean = false>(options: Options<TruckRecordingMipControllerGetVolumeEstimationData, ThrowOnError>) {
        return (options?.client ?? client).get<TruckRecordingMipControllerGetVolumeEstimationResponse, TruckRecordingMipControllerGetVolumeEstimationError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/truck-recordings-mip/{mipReportId}/predictions/volume-estimation'
        });
    }
    
}

export class TrainRecordingService {
    /**
     * Get recordings of trains for a jobsite
     */
    public static trainRecordingControllerGetRecordings<ThrowOnError extends boolean = false>(options: Options<TrainRecordingControllerGetRecordingsData, ThrowOnError>) {
        return (options?.client ?? client).get<TrainRecordingControllerGetRecordingsResponse, TrainRecordingControllerGetRecordingsError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/train-recordings'
        });
    }
    
    /**
     * Get the available filter values and counts for a query
     */
    public static trainRecordingControllerGetFilterOptions<ThrowOnError extends boolean = false>(options: Options<TrainRecordingControllerGetFilterOptionsData, ThrowOnError>) {
        return (options?.client ?? client).get<TrainRecordingControllerGetFilterOptionsResponse, TrainRecordingControllerGetFilterOptionsError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/train-recordings/filter-options'
        });
    }
    
    /**
     * Get a specific recording for a train
     */
    public static trainRecordingControllerGetRecording<ThrowOnError extends boolean = false>(options: Options<TrainRecordingControllerGetRecordingData, ThrowOnError>) {
        return (options?.client ?? client).get<TrainRecordingControllerGetRecordingResponse, TrainRecordingControllerGetRecordingError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/train-recordings/{recordingId}'
        });
    }
    
    /**
     * Get the number of aux capturers for a specific recording
     */
    public static trainRecordingControllerGetAuxCaptures<ThrowOnError extends boolean = false>(options: Options<TrainRecordingControllerGetAuxCapturesData, ThrowOnError>) {
        return (options?.client ?? client).get<TrainRecordingControllerGetAuxCapturesResponse, TrainRecordingControllerGetAuxCapturesError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/train-recordings/{recordingId}/aux-captures'
        });
    }
    
    /**
     * Get the number of aux captures for a specific capturer of a specific recording
     */
    public static trainRecordingControllerGetAuxImages<ThrowOnError extends boolean = false>(options: Options<TrainRecordingControllerGetAuxImagesData, ThrowOnError>) {
        return (options?.client ?? client).get<TrainRecordingControllerGetAuxImagesResponse, TrainRecordingControllerGetAuxImagesError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/train-recordings/{recordingId}/aux-captures/{numAux}/images'
        });
    }
    
    /**
     * Get a specific aux image for a recording
     */
    public static trainRecordingControllerGetAuxImage<ThrowOnError extends boolean = false>(options: Options<TrainRecordingControllerGetAuxImageData, ThrowOnError>) {
        return (options?.client ?? client).get<TrainRecordingControllerGetAuxImageResponse, TrainRecordingControllerGetAuxImageError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/train-recordings/{recordingId}/aux-captures/{numAux}/images/{numImage}'
        });
    }
    
    /**
     * Get the wagon number image for a specific recording
     */
    public static trainRecordingControllerGetWagonNumberImage<ThrowOnError extends boolean = false>(options: Options<TrainRecordingControllerGetWagonNumberImageData, ThrowOnError>) {
        return (options?.client ?? client).get<TrainRecordingControllerGetWagonNumberImageResponse, TrainRecordingControllerGetWagonNumberImageError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/train-recordings/{recordingId}/wagon-number/image'
        });
    }
    
}

export class HeapRecordingService {
    /**
     * Get heap recordings for a jobsite
     */
    public static heapRecordingControllerGetRecordings<ThrowOnError extends boolean = false>(options: Options<HeapRecordingControllerGetRecordingsData, ThrowOnError>) {
        return (options?.client ?? client).get<HeapRecordingControllerGetRecordingsResponse, HeapRecordingControllerGetRecordingsError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/heap-recordings'
        });
    }
    
    /**
     * Get available filter values and counts for heap recordings
     */
    public static heapRecordingControllerGetFilterOptions<ThrowOnError extends boolean = false>(options: Options<HeapRecordingControllerGetFilterOptionsData, ThrowOnError>) {
        return (options?.client ?? client).get<HeapRecordingControllerGetFilterOptionsResponse, HeapRecordingControllerGetFilterOptionsError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/heap-recordings/filter-options'
        });
    }
    
    /**
     * Update every camera recording belonging to a heap batch
     */
    public static heapRecordingControllerUpdateRecordingBatch<ThrowOnError extends boolean = false>(options: Options<HeapRecordingControllerUpdateRecordingBatchData, ThrowOnError>) {
        return (options?.client ?? client).put<void, unknown, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/heap-recordings/batch/{batchId}'
        });
    }
    
}

export class BeltObservationService {
    /**
     * Get belt observations for a jobsite
     */
    public static beltControllerGetBeltObservations<ThrowOnError extends boolean = false>(options: Options<BeltControllerGetBeltObservationsData, ThrowOnError>) {
        return (options?.client ?? client).get<BeltControllerGetBeltObservationsResponse, BeltControllerGetBeltObservationsError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/belt-observations'
        });
    }
    
    /**
     * Get the calendar days that have belt observations for a jobsite
     */
    public static beltControllerGetBeltObservationDays<ThrowOnError extends boolean = false>(options: Options<BeltControllerGetBeltObservationDaysData, ThrowOnError>) {
        return (options?.client ?? client).get<BeltControllerGetBeltObservationDaysResponse, BeltControllerGetBeltObservationDaysError, ThrowOnError>({
            ...options,
            url: '/api/jobsites/{jobsiteId}/belt-observations/days'
        });
    }
    
}